<template>
	<div class="wrapperBlock">
		<row align-items="flex-start" justify-content="space-between">
			<span class="wrapperBlock_title">Dispatch</span>
			<row justify-content="flex-end">
			  <field
					  margin="0 20px 0 0"
					  padding="0"
					  height="24"
					  label-switch="Loads .xls"
					  :switch-value="xlsSwitcher"
					  @updateSwitch="onCheckbox($event, 'xlsSwitcher')"
					  is-dense
					  is-switch
					  is-off-style
			  ></field>
			  <field
					  margin="0"
					  padding="0"
					  height="24"
					  label-switch="Report"
					  :switch-value="switcherReport"
					  @updateSwitch="onCheckbox($event, 'switcherReport')"
					  is-dense
					  is-switch
					  is-off-style
			  ></field>
			</row>
		</row>
		<div class="wrapperBlock_body mr-20">
			<p class="subtext">Loads in invoice</p>
			<main-table
					padding="0 0 10px"
					:flag="flag"
					:headers="getHeaders"
					:listItems="invoiceLoads"
					@updateClickButton="onClickButton($event, flag)"
					@updateHandleTable="onHandleTable($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
		<p class="subtext">Not payed loads for selected period</p>
		<div class="wrapperBlock_body mr-20">
			<main-table
					padding="0 0 10px"
					:flag="flag"
					:headers="getActiveHeaders"
					:listItems="loads"
					@updateClickButton="onClickButton($event, flag)"
					@updateHandleTable="onHandleTable($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
		<p class="subtext">Not payed loads for previous period</p>
		<div class="wrapperBlock_body">
			<main-table
					padding="0 0 10px"
					:flag="flag"
					:headers="getActiveHeaders"
					:listItems="loadsOld"
					@updateClickButton="onClickButton($event, flag)"
					@updateHandleTable="onHandleTable($event, flag, 1)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
	</div>
</template>

<script>
import {
	billingActiveHeader,
	billingHeader
} from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";

export default {
	name: "BlockDispatch",
	props: {
		flag: String,
		switcherReport: Boolean,
		xlsSwitcher: Boolean,
		loadsOld: Array,
		invoiceLoads: Array,
		loads: Array
	},
	computed: {
		getActiveHeaders() {
			return billingActiveHeader;
		},
		getHeaders() {
			return billingHeader;
		}
	},
	methods: {
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updateEditInvoice', { key, item, nameComponent });
		},
		onHandleTable(key, nameComponent, isOld) {
			this.$emit('updateEditInvoice', { key, nameComponent, isOld });
		},
		onCheckbox({ value }, key) {
			this.$emit('updateCheckbox', { value, key });
		}
	}
};
</script>
<style scoped lang="scss">
@import "../blockStyles";
</style>
